<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-center justify-between px-6 pb-4 pt-6">
    <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.SALES_OFFICE_MODAL.TITLE' | t }}</h2>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- aviso -->
  @if (data.notice) {
  <div class="flex items-start gap-3 border-y border-amber-300 bg-amber-50 px-6 py-4 text-base text-amber-800 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-200">
    <mat-icon class="icon-size-6 text-amber-600 dark:text-amber-300">warning</mat-icon>
    <span>{{ data.notice }}</span>
  </div>
  }

  <!-- buscador -->
  <div class="px-6 pt-4">
    <div class="flex items-center gap-2 rounded-xl border px-3 py-2">
      <mat-icon class="text-secondary icon-size-5">search</mat-icon>
      <input type="text" [(ngModel)]="search"
        [placeholder]="'DOCUMENT_GENERATE.SALES_OFFICE_MODAL.SEARCH_PLACEHOLDER' | t"
        class="w-full bg-transparent text-base outline-none" />
    </div>
  </div>

  <!-- lista de oficinas -->
  <div class="min-h-0 flex-1 overflow-auto px-6 py-4">
    <div class="flex flex-col gap-3">
      @for (o of filteredOffices(); track o._id) {
      <div
        class="flex items-center gap-3 rounded-xl border p-4 transition-colors"
        [class.cursor-pointer]="selectable(o)"
        [class.opacity-60]="!selectable(o)"
        [class.border-primary]="isSelected(o)"
        [class.bg-primary-50]="isSelected(o)"
        [class.dark:bg-primary-900]="isSelected(o)"
        (click)="select(o)">
        <mat-checkbox [checked]="isSelected(o)" [disabled]="!selectable(o)" (change)="select(o)"
          (click)="$event.stopPropagation()"></mat-checkbox>
        <div class="flex min-w-0 flex-1 flex-col gap-0.5">
          <span class="text-secondary text-xs font-medium">{{ codeOf(o) }}</span>
          <span class="leading-snug">{{ o.name }}</span>
        </div>
        @if (!selectable(o)) {
        <span class="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">
          {{ 'DOCUMENT_GENERATE.SALES_OFFICE_MODAL.NO_WAREHOUSE' | t }}
        </span>
        }
      </div>
      } @empty {
      <div class="text-secondary flex h-32 items-center justify-center text-base">
        {{ 'DOCUMENT_GENERATE.SALES_OFFICE_MODAL.EMPTY' | t }}
      </div>
      }
    </div>
  </div>

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!selectedId" (click)="confirm()">
      {{ 'DOCUMENT_GENERATE.ACTIONS.CONFIRM' | t }}
    </button>
  </div>
</div>
